module.exports = require('./helpers/bundle-url').getBundleURL('79Wa6') + "logo.5ec3ca99.svg";